const API_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:4000' 
  : 'https://showflow.creativevideoservices.net';

const getToken = () => localStorage.getItem('cvs_token');

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`
});

// ─── AUTH ──────────────────────────────────────────────────────────────────────

export const login = async (email, password) => {
  const res = await fetch(`${API_URL}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  return res.json();
};

export const verifyToken = async () => {
  const res = await fetch(`${API_URL}/api/verify`, { headers: headers() });
  return res.json();
};

// ─── SHOWS ─────────────────────────────────────────────────────────────────────

export const getShows = async () => {
  const res = await fetch(`${API_URL}/api/shows`, { headers: headers() });
  return res.json();
};

export const createShow = async (name) => {
  const res = await fetch(`${API_URL}/api/shows`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ name })
  });
  return res.json();
};

export const updateShow = async (id, data) => {
  const res = await fetch(`${API_URL}/api/shows/${id}`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(data)
  });
  return res.json();
};

export const deleteShow = async (id) => {
  const res = await fetch(`${API_URL}/api/shows/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
};

// ─── PRESENTERS ────────────────────────────────────────────────────────────────

export const getPresenters = async () => {
  const res = await fetch(`${API_URL}/api/presenters`, { headers: headers() });
  return res.json();
};

export const createPresenter = async (presenter) => {
  const res = await fetch(`${API_URL}/api/presenters`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(presenter)
  });
  return res.json();
};

export const updatePresenter = async (id, presenter) => {
  const res = await fetch(`${API_URL}/api/presenters/${id}`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(presenter)
  });
  return res.json();
};

export const deletePresenter = async (id) => {
  const res = await fetch(`${API_URL}/api/presenters/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
};

// ─── LISTS ─────────────────────────────────────────────────────────────────────

export const getLists = async () => {
  const res = await fetch(`${API_URL}/api/lists`, { headers: headers() });
  return res.json();
};

export const updateLists = async (lists) => {
  const res = await fetch(`${API_URL}/api/lists`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(lists)
  });
  return res.json();
};

// ─── USERS ─────────────────────────────────────────────────────────────────────

export const getUsers = async () => {
  const res = await fetch(`${API_URL}/api/users`, { headers: headers() });
  return res.json();
};

export const createUser = async (user) => {
  const res = await fetch(`${API_URL}/api/users`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(user)
  });
  return res.json();
};

export const deleteUser = async (id) => {
  const res = await fetch(`${API_URL}/api/users/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
};

export const updatePassword = async (id, password) => {
  const res = await fetch(`${API_URL}/api/users/${id}/password`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify({ password })
  });
  return res.json();
};

// ─── PERMISSIONS ───────────────────────────────────────────────────────────────

export const getShowPermissions = async (showId) => {
  const res = await fetch(`${API_URL}/api/shows/${showId}/permissions`, { headers: headers() });
  return res.json();
};

export const addShowPermission = async (showId, userId, permission) => {
  const res = await fetch(`${API_URL}/api/shows/${showId}/permissions`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ userId, permission })
  });
  return res.json();
};

export const removeShowPermission = async (showId, userId) => {
  const res = await fetch(`${API_URL}/api/shows/${showId}/permissions/${userId}`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
};

export const updateUserRole = async (id, role) => {
  const res = await fetch(`${API_URL}/api/users/${id}/role`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify({ role })
  });
  return res.json();
};
// ─── SNAPSHOTS ─────────────────────────────────────────────────────────────────

export const getSnapshots = async (showId) => {
  const res = await fetch(`${API_URL}/api/shows/${showId}/snapshots`, { headers: headers() });
  return res.json();
};

export const restoreSnapshot = async (showId, snapshotId) => {
  const res = await fetch(`${API_URL}/api/shows/${showId}/snapshots/${snapshotId}/restore`, {
    method: 'POST',
    headers: headers()
  });
  return res.json();
};
// ─── DELETED SHOWS ─────────────────────────────────────────────────────────────

export const getDeletedShows = async () => {
  const res = await fetch(`${API_URL}/api/shows/deleted/list`, { headers: headers() });
  return res.json();
};

export const undeleteShow = async (id) => {
  const res = await fetch(`${API_URL}/api/shows/${id}/undelete`, {
    method: 'POST',
    headers: headers()
  });
  return res.json();
};

export const permanentlyDeleteShow = async (id) => {
  const res = await fetch(`${API_URL}/api/shows/${id}/permanent`, {
    method: 'DELETE',
    headers: headers()
  });
  return res.json();
};